import type { IRoleRepository } from '@src/domain/rbac/repository/role_repository';

/**
 * Remove Permissions from Role Use Case
 * Removes multiple permissions from a role in batch
 */
export class RemovePermissionsFromRoleUseCase {
    constructor(private readonly roleRepository: IRoleRepository) { }

    async execute(
        roleId: string,
        permissionNames: string[]
    ): Promise<{ message: string; removedPermissions: string[] }> {
        return await this.roleRepository.removePermissions(roleId, permissionNames);
    }
}
